import { usePost, useGet } from '@/api/lib/integration.ts';
import type { ExtractDocumentResponse } from '@/api/documents/types.ts';

export const extractDocument = usePost<{ uploadIds: number[] }, ExtractDocumentResponse>('/api/upload/extract-contract-data');

export const getExtractionAvailabilityStatus = useGet<void, { enabled: boolean }>('/api/upload/contract-data-extraction-status');
